{
  "en": {
    "documentContract": {
      "addContractSuccess": "Contract added successfully",
      "addContractError": "An error occured while adding the contract",
      "replaceContractSuccess": "Contract replaced successfully"
    }
  },
  "fr": {
    "documentContract": {
      "addContractSuccess": "Contrat ajouté avec succès",
      "addContractError": "Une erreur s'est produite lors de l'ajout du contrat",
      "replaceContractSuccess": "Contrat remplacé avec succès"
    }
  },
  "nl": {
    "documentContract": {
      "addContractSuccess": "Contract succesvol toegevoegd",
      "addContractError": "Er is een fout opgetreden bij het toevoegen van het contract",
      "replaceContractSuccess": "Contract succesvol vervangen"
    }
  }
}
